import { DatePicker } from 'baseui/datepicker';
import { PopoverProps } from 'baseui/popover';
import { Tag } from 'baseui/tag';
import { ButtonProps } from 'components/elements/buttons/button';
import React from 'react';

export const tagOverridesStyles: React.ComponentProps<typeof Tag>['overrides'] =
  {
    Root: {
      style: {
        borderTopLeftRadius: '36px',
        borderTopRightRadius: '36px',
        borderBottomLeftRadius: '36px',
        borderBottomRightRadius: '36px',
        height: '36px',
        margin: '0px !important',
        width: 'fit-content',
      } as React.CSSProperties,
    },
    Action: {
      style: {
        borderTopRightRadius: '36px',
        borderBottomRightRadius: '36px',
        height: '22px',
      } as React.CSSProperties,
    },
    Text: {
      style: {
        width: '100%',
        maxWidth: '1000px',
      } as React.CSSProperties,
    },
  };

export const masterDatePickerOverridesStyles: React.ComponentProps<
  typeof DatePicker
>['overrides'] = {
  MonthYearSelectPopover: {
    props: {
      overrides: {
        Body: {
          style: {
            zIndex: 1000,
          },
        },
      },
    },
  },
  Popover: {
    props: {
      overrides: {
        Body: {
          style: {
            zIndex: 1000,
          },
        },
      },
    },
  },
};

export const filterButtonOverridesStyles: ButtonProps['overrides'] = {
  Root: {
    style: {
      borderRadius: '4px',
      height: '36px',
      marginRight: '8px',
    } as React.CSSProperties,
  },
};

export const filterPopoverOverridesStyles: PopoverProps['overrides'] = {
  Inner: {
    style: {
      maxHeight: '450px',
      overflow: 'auto',
      zIndex: '999',
    },
  },
  Body: {
    style: {
      zIndex: 999,
    },
  },
};
